import { variablesGlobales } from "../../configs/variables";

export const firmaElectronica = 145000;

export const calcDescuentoFirmaElectronicaV1 = (requestedAmount, termInDays) => {
    return variablesGlobales.dctoFirmaElectronica;
}